import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { CONTACT } from "@/data/site";
import { LogoMark } from "@/components/Logo";

export function PublicFooter() {
  return (
    <footer data-testid="public-footer" className="bg-navy-900 border-t border-white/10 text-slate-300">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div>
          <div className="flex items-center gap-3">
            <LogoMark size={36} />
            <span className="font-display font-extrabold text-white text-xl tracking-tight">VM-FFM<span className="text-gold-500">.DE</span></span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-slate-400 max-w-xs">
            Ihr unabhängiger Partner für Versicherung, Finanzierung und Immobilien im Rhein-Main-Gebiet – seit über 20 Jahren auf Ihrer Seite.
          </p>
        </div>
        <div>
          <h4 className="text-xs tracking-[0.2em] uppercase font-bold text-gold-500 mb-4">Leistungen</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/versicherungen" className="hover:text-gold-500">Versicherungen</Link></li>
            <li><Link to="/finanzierung" className="hover:text-gold-500">Finanzierung</Link></li>
            <li><Link to="/immobilien" className="hover:text-gold-500">Immobilien</Link></li>
            <li><Link to="/ueber-uns" className="hover:text-gold-500">Über uns</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs tracking-[0.2em] uppercase font-bold text-gold-500 mb-4">Service</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/termin-buchen" className="hover:text-gold-500">Termin buchen</Link></li>
            <li><Link to="/schaden-melden" className="hover:text-gold-500">Schaden melden</Link></li>
            <li><Link to="/finanzierung/rechner" className="hover:text-gold-500">Finanzierungsrechner</Link></li>
            <li><Link to="/ratgeber" className="hover:text-gold-500">Ratgeber</Link></li>
            <li><Link to="/faq" className="hover:text-gold-500">FAQ</Link></li>
            <li><Link to="/downloads" className="hover:text-gold-500">Download-Center</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs tracking-[0.2em] uppercase font-bold text-gold-500 mb-4">Kontakt</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2"><MapPin size={16} className="text-gold-500 shrink-0" /> {CONTACT.city}</li>
            <li className="flex items-center gap-2"><Phone size={16} className="text-gold-500 shrink-0" /> <a href={`tel:${CONTACT.phoneHref}`} className="hover:text-gold-500">{CONTACT.phone}</a></li>
            <li className="flex items-center gap-2"><Mail size={16} className="text-gold-500 shrink-0" /> <a href={`mailto:${CONTACT.email}`} className="hover:text-gold-500">{CONTACT.email}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-slate-500">
          <span>© {new Date().getFullYear()} {CONTACT.company}. Vermittlerregister §34d GewO.</span>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <Link to="/impressum" className="hover:text-gold-500">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-gold-500">Datenschutz</Link>
            <Link to="/agb" className="hover:text-gold-500">AGB</Link>
            <Link to="/erstinformation" className="hover:text-gold-500">Erstinformation</Link>
            <Link to="/cookie-einstellungen" className="hover:text-gold-500">Cookie-Einstellungen</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
